export default {
  title: '注册账号',
  username: '用户名',
  mobile: '手机',
  code: '请输入验证码',
  password: '请输入密码',
  confirm: '请确认密码',
  email: '邮箱',
  agree: '同意',
  agreement: '《泛函用户协议》',
  agreement2: '《泛函隐私政策》',
  register: '注册',
  mailReg: '邮箱注册',
  phoneReg: '手机注册',
  js: {
    error: '失败',
    success: '成功',
    sendAgain: '重新发送',
    send: '发送验证码',
    check: '请勾选协议'
  },
  loginType: {
    password: '密码登录',
    sms: '短信登录'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/register.js